<template>

  <div class="columns is-centered is-vcentered">

    <div class="column is-three-fifths-desktop is-four-fifths-tablet">

      <div class="card" style="padding: 30px 30px; margin-top: 35px;" :style="{opacity: (submitInProgress ? 0.3 : 1)}">
        <div class="card-content">

        <b-field label="Name" style="text-align: left;">
          <b-input v-model="name" v-focus placeholder="The event's name" required></b-input>
        </b-field>

        <b-field label="Short name" style="text-align: left;">
          <b-input v-model="shortName" placeholder="Short event name" required maxlength="15"></b-input>
        </b-field>


          <b-field label="Event type" style="text-align: left;">
            <b-select v-model="type" placeholder="Select..." expanded required>
              <option value="singles">Singles</option>
              <option value="doubles">Doubles</option>
            </b-select>
          </b-field>

        <p v-if="failedSubmit" style="margin-top: 27px; text-align: left; color: red;">Please make sure you complete all fields.</p>


        <div style="text-align: right;">
          <button class="button is-danger" v-if="id" style="margin-top: 25px; margin-bottom: -10px; margin-right: 30px;" @click="deleteEvent">Delete</button>
          <button class="button is-primary" style="margin-top: 25px; margin-bottom: -10px;" @click="triggerSubmit">Submit changes</button>
        </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from '../request';
import TournamentDataMixin from '../mixins/TournamentDataMixin.js';

export default {
  mixins: [ TournamentDataMixin ],

  data: function() {
    return {
      name: '',
      shortName: '',
      type: null,

      submitInProgress: false,
      failedSubmit: false
    }
  },

  computed: {
    id: function() { return this.$route.params.event; },
  },

  watch: {
    tournament: {
      immediate: true,

      handler() {
        if (this.tournament && this.id) {
          let event = this.tournament.events.filter(event => event.id == this.id);
          if (event && event.length > 0) {
            this.name = event[0].name;
            this.shortName = event[0].shortName;
            this.type = event[0].type;
          }
        }
      }
    }
  },

  methods: {
    deleteEvent: function() {
      let event = this.tournament.events.filter(event => event.id == this.id)[0];

      this.$dialog.confirm({
        message: 'Are you sure you want to delete this event?\nThis action will only succeed if no draws or entries are defined.',
        type: 'is-danger',
        onConfirm: () => { this.$store.dispatch('deleteItem', { type: 'event', item: event }); }
      });
    },

    triggerSubmit: function() {

      if (this.submitInProgress) {
        return /* don't do multiple requests */;
      }

      let vm = this;
      vm.submitInProgress = true;
      vm.failedSubmit = false;

      let tournamentId = this.$route.params.id;

      axios.post('/api/tournament/' + tournamentId + '/events', {
        name: this.name,
        shortName: this.shortName,
        type: this.type,

        id: this.id
      })
        .then(function(response){
          vm.submitInProgress = false;
          vm.failedSubmit = false;

          vm.$store.dispatch('tournamentEventsChanged', { tournamentId: tournamentId, events: response.data });
        })
        .catch(function(){
          vm.submitInProgress = false;
          vm.failedSubmit = true;
        });

    }
  },

  name: 'edit-events'
}
</script>



<style scoped>

</style>